export default __webpack_public_path__ + "static/media/crossmark.b559cc06.svg";